<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)" 
  >
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>

    <v-dialog
      ref="dialog"
      v-model="modal"
      v-bind="schema.attributesDialog"
      :disabled="schema.attributesTextField.readonly"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-bind="schema.attributesTextField"
          :disabled="schema.readonly"
          :value="formattedDate"
          :rules="rules"
          :name="schema.model"
          :id="generateId(schema.model)"
          @click:clear="clear"
          v-on="on"
        >
          <template v-slot:label>
            {{ schema.attributesTextField.label }}
            <span v-if="schema.rules.includes('required')" class="red--text">*</span>
          </template>
        </v-text-field>
      </template>

      <v-date-picker
        @change="onChange"
        @focus="onFocus"
        @input="modal = false"
        v-model="due"
        v-bind="schema.attributesDatePicker"
        :min="valueDateMin"
        :max="valueDateMax"
        v-if="!schema.attributesTextField.readonly"
      >
        <v-spacer></v-spacer>
        <v-btn v-if="schema.btnShow" :text="schema.btnFlat" :color="schema.btnCancelColor" @click="modal = false">{{
          schema.btnCancelLabel
        }}</v-btn>

        <v-btn
          v-if="schema.btnShow"
          :text="schema.btnFlat"
          :color="schema.btnSaveColor"
          @click="$refs.dialog.save(value)"
          >{{ schema.btnSaveLabel }}</v-btn
        >
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import moment from 'moment';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';
import { compilerOperationDate } from '@/helpers/utils';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data: () => ({
    modal: false,
    due: null
  }),

  computed: {
    formattedDate() {
      if (this.due) return moment(this.due).format('DD/MM/YYYY');

      if (this.model && this.model[this.schema.model]) {
        this.due = new Date(this.model[this.schema.model]).toISOString().substr(0, 10);
        return moment(this.model[this.schema.model]).format('DD/MM/YYYY');
      }

      return '';
    },
    valueDateMin() {
      if (('rangeDate' in this.schema) && ('min' in this.schema.rangeDate)) {
        return compilerOperationDate(this.schema.rangeDate.min);
      }
      return undefined;
    },
    valueDateMax() {
      if (('rangeDate' in this.schema) && ('max' in this.schema.rangeDate)) {
        return compilerOperationDate(this.schema.rangeDate.max);
      }
      return undefined;
    },
  },

  watch: {
    value(newValue) {
      this.due = newValue ? moment(newValue).format('YYYY-MM-DD') : null;
    }
  },

  methods: {
    onChange: async function () {
      this.value = this.due;
      this.changeEvents();
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    }
  }
};
</script>
